/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
/* eslint-disable no-unsafe-optional-chaining */
import { routes } from '@constants';
import { courseApi, testApi, userApi } from '@store';
import { useIndexedDB } from 'react-indexed-db-hook';

import { updateCompletedStatusesInLessons } from '../helpers/offline';
import { useOnlineStatusDetector } from './useOnlineStatusDetector';

const { useEffect, useMemo, useState } = require('react');

const getDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const getDescriptionByOptionId = (data, optionId) => {
  for (const step of data.steps) {
    for (const option of step.options) {
      if (option.id === optionId) {
        return option.description;
      }
    }
  }
};

export const useModuleData = ({ currentActivity, moduleId, moduleTest }) => {
  const { isOnline } = useOnlineStatusDetector();
  const { getByID, update: updateModule } = useIndexedDB('modules');
  const {
    add: addLessonActivity,
    getAll: getAllCompletedLessonActivities,
    getByID: getLessonctivityByID,
    update: updateLessonActivity,
  } = useIndexedDB('completed_lesson_activity');
  const {
    add: addLesson,
    getAll: getAllCompletedLessons,
    getByID: getByIDLesson,
    update: updateLesson,
  } = useIndexedDB('completed_lesson');
  const {
    add: addCourseModule,
    // getAll: getAllCompletedCourseModule,
    getByID: getByIDCourseModule,
    update: updateCourseModule,
  } = useIndexedDB('completed_course_module');
  const {
    add: addTestStep,
    getAll: getAllTestSteps,
    update: updateTestStep,
  } = useIndexedDB('completed_test_step');
  const {
    add: addTest,
    getAll: getAllTests,
    update: updateTest,
  } = useIndexedDB('completed_test');
  const userId = useMemo(() => {
    const items = { ...localStorage };
    return items && items['persist:persistor']
      ? JSON.parse(JSON.parse(items['persist:persistor']).authSlice).userId
      : null;
  }, [localStorage]);

  const [offlineModule, setOfflineModule] = useState();
  const [currectActivity, setCurrectActivity] = useState();

  // const getAllDataInDB = async () => {
  //   const completed_lesson_activity = await getAllCompletedLessonActivities();
  //   const completed_lesson = await getAllCompletedLessons();
  //   const completed_course_module = await getAllCompletedCourseModule();
  //   const completed_test_step = await getAllTestSteps();
  //   const completed_test = await getAllTests();
  //   const response = {
  //     completed_course_module,
  //     completed_lesson,
  //     completed_lesson_activity,
  //     completed_test,
  //     completed_test_step,
  //   };
  //   console.log(responce);
  // };

  const startNewActivity = async (newActivityID) => {
    const lessonWithActivity = offlineModule?.lessons?.find((lesson) =>
      lesson?.activities?.map((el) => el.id)?.includes(newActivityID)
    );
    const isFirstLesson = !!(
      lessonWithActivity &&
      offlineModule?.lessons.indexOf(lessonWithActivity) === 0
    );

    const isFirstActivity =
      lessonWithActivity?.activities.indexOf(
        lessonWithActivity?.activities?.find((act) => act.id === newActivityID)
      ) === 0;

    const datetime = getDateTime();

    await addLessonActivity({
      id: newActivityID,
      started_at: datetime,
      user_id: userId,
    });
    // add start time for the module if the lesson is the first one
    if (isFirstLesson && isFirstActivity) {
      await addCourseModule({
        id: offlineModule?.id,
        started_at: datetime,
        user_id: userId,
      });
    }
    // add start time for the lesson if the activity is the first one
    if (isFirstActivity) {
      await addLesson({
        id: lessonWithActivity?.id,
        started_at: datetime,
        user_id: userId,
      });
    }
    // to do add start time for the whole course
  };

  const endOldActivity = async (oldActivityID) => {
    const lessonWithActivity = offlineModule?.lessons?.find((lesson) =>
      lesson?.activities?.map((el) => el.id)?.includes(oldActivityID)
    );
    const isLastLesson = !!(
      lessonWithActivity &&
      offlineModule?.lessons.indexOf(lessonWithActivity) ===
        offlineModule?.lessons.length - 1
    );

    const isLastActivity = offlineModule?.lessons.some(
      (lesson) =>
        lesson.activities &&
        lesson.activities.slice(-1)[0]?.id === oldActivityID
    );
    // add completed_at for the activity
    const datetime = getDateTime();
    const lessonActivityInDB = await getLessonctivityByID(oldActivityID);
    await updateLessonActivity({
      ...lessonActivityInDB,
      completed_at: datetime,
      completion_type: 'manual',
      id: oldActivityID,
    });
    // add completed_at for the lesson if the activity is the first one
    if (isLastActivity) {
      const lessonInDB = await getByIDLesson(lessonWithActivity?.id);
      await updateLesson({
        ...lessonInDB,
        completed_at: datetime,
        completion_type: 'manual',
        id: lessonWithActivity?.id,
      });
    }
    // add completed_at for the module if the lesson is the first one
    if (isLastLesson) {
      const courseModuleInDB = await getByIDCourseModule(
        lessonWithActivity?.id
      );
      await updateCourseModule({
        ...courseModuleInDB,
        completed_at: datetime,
        id: offlineModule?.id,
      });
    }
    // to do add completed_at for the whole course
  };

  const getLessonsWithCompletedStatuses = async (lessons, activityId = -1) => {
    const completedLessons = await getAllCompletedLessons();
    const completedLessonActivities = await getAllCompletedLessonActivities();

    return updateCompletedStatusesInLessons({
      activityId,
      completedLessonActivities,
      completedLessons,
      lessons,
    });
  };

  const findNextActivityID = (activityID) => {
    const lessonWithActivity = offlineModule?.lessons?.find((lesson) =>
      lesson?.activities?.map((el) => el.id)?.includes(activityID)
    );

    const isLastActivity = offlineModule?.lessons.some(
      (lesson) =>
        lesson.activities && lesson.activities.slice(-1)[0]?.id === activityID
    );

    if (!isLastActivity) {
      const nextActivityID =
        lessonWithActivity?.activities[
          lessonWithActivity?.activities.findIndex(
            (activity) => activity.id === activityID
          ) + 1
        ]?.id;
      const nextActivitylessonID = lessonWithActivity?.id;
      return { nextActivityID, nextActivitylessonID };
    }

    const isLastLesson = !!(
      lessonWithActivity &&
      offlineModule?.lessons.indexOf(lessonWithActivity) ===
        offlineModule?.lessons.length - 1
    );

    if (!isLastLesson) {
      const nextActivitylesson =
        offlineModule?.lessons[
          offlineModule?.lessons.indexOf(lessonWithActivity) + 1
        ];
      const nextActivitylessonID = nextActivitylesson?.id;
      const nextActivityID = nextActivitylesson?.activities[0]?.id;
      return { nextActivityID, nextActivitylessonID };
    }
    // to do: else we go to the final test
  };

  const validateTestLocal = async ({ data: { testAnswers }, id }) => {
    const allTests = await getAllTests();
    const neededTest = allTests.find(
      (tst) => tst.test_id === id && !tst.completed_at
    );

    const correctAnswers = testAnswers.filter(
      (testAnswer) =>
        moduleTest?.steps
          .find((el) => testAnswer.testStepId === el.id)
          ?.options.find((option) => option.id === testAnswer?.optionId)
          ?.is_correct
    );

    const correct_answers = correctAnswers?.length || 0;
    const validated_answers = moduleTest?.steps.map((testStep) => ({
      ...testStep,
      correct_answer: testStep?.options.find((o) => o.is_correct === true),
      explanation: correctAnswers.find((el) => el.testStepId === testStep.id)
        ? null
        : testStep?.explanation,
      is_correct: !!correctAnswers.find((el) => el.testStepId === testStep.id),

      option_description: getDescriptionByOptionId(
        moduleTest,
        testAnswers?.find((tstAnsw) => tstAnsw.testStepId === testStep.id)
          ?.optionId
      ),
    }));

    const isPassed = correct_answers === testAnswers.length;

    await updateTest({
      ...neededTest,
      completed_at: getDateTime(),
      correct_answers,
    });

    if (isPassed && moduleTest?.module_id) {
      const tempModule = await getByID(moduleTest?.module_id);
      if (tempModule) {
        await updateModule({
          ...tempModule,
          is_completed: true,
        });
      }
    }

    return {
      data: { correct_answers, is_passed: isPassed, validated_answers },
    };
  };

  const updateTestProgressLocal = async (data) => {
    const allTestSteps = await getAllTestSteps();
    const neededTest = allTestSteps.find(
      (testStep) =>
        testStep.test_step_id === data?.passedStep.id && !testStep.completed_at
    );
    await updateTestStep({
      ...neededTest,
      choosen_test_step_option_id: data?.passedStep?.chosenOptionId,
      completed_at: getDateTime(),
      test_step_id: data?.passedStep.id,
    });
    const prevStepIndexById = moduleTest?.steps?.indexOf(
      moduleTest?.steps?.find((stp) => stp?.id === data?.passedStep.id)
    );
    if (prevStepIndexById !== moduleTest?.steps.length - 1) {
      await addTestStep({
        started_at: getDateTime(),
        test_step_id: moduleTest.steps[prevStepIndexById + 1]?.id,
        user_id: userId,
      });
    }
  };

  const createTestProgressLocal = async ({ testId }) => {
    const previousTests = await getAllTests();
    await addTest({
      attempt_number: previousTests?.length > 0 ? previousTests?.length + 1 : 1,
      started_at: getDateTime(),
      test_id: testId,
      user_id: userId,
    });
    await addTestStep({
      started_at: getDateTime(),
      test_step_id: moduleTest.steps[0]?.id,
      user_id: userId,
    });
  };

  const checkIsTestNext = (actID) => {
    const lessonWithActivity = offlineModule?.lessons?.find((lesson) =>
      lesson?.activities?.map((el) => el.id)?.includes(actID)
    );

    const isLastActivity = offlineModule?.lessons.some(
      (lesson) =>
        lesson.activities && lesson.activities.slice(-1)[0]?.id === actID
    );

    const isLastLesson = !!(
      lessonWithActivity &&
      offlineModule?.lessons.indexOf(lessonWithActivity) ===
        offlineModule?.lessons.length - 1
    );
    return isLastActivity && isLastLesson;
  };

  const updateProgressLocal = async (activityID) => {
    await endOldActivity(activityID.activityId);
    const isTestNext = checkIsTestNext(activityID.activityId);
    if (isTestNext) {
      setCurrectActivity({
        ...offlineModule?.final_test,
        content_type: 'test',
      });
    } else {
      const { nextActivityID, nextActivitylessonID } = findNextActivityID(
        activityID.activityId
      );
      const updatedLessons = await getLessonsWithCompletedStatuses(
        offlineModule.lessons,
        activityID.activityId
      );

      setOfflineModule((prev) => ({
        ...prev,
        current_lesson: {
          current_activity_id: nextActivityID,
          id: nextActivitylessonID,
        },
        lessons: updatedLessons,
      }));
    }
  };

  useEffect(() => {
    const init = async () => {
      if (offlineModule?.current_lesson?.current_activity_id) {
        const response = await getLessonctivityByID(
          offlineModule?.current_lesson?.current_activity_id
        );

        if (!response) {
          startNewActivity(offlineModule?.current_lesson?.current_activity_id);
        }
      } else {
        // set current activity

        await updateModule({
          ...offlineModule,
          current_lesson: {
            current_activity_id:
              offlineModule?.lessons?.[0]?.activities?.[0]?.id,
            id: offlineModule?.lessons?.[0]?.id,
          },
        });
        const refetchedModule = await getByID(offlineModule?.id);
        setOfflineModule(refetchedModule);
        startNewActivity(refetchedModule?.lessons?.[0]?.activities?.[0]?.id);
      }
    };
    if (offlineModule) init();
  }, [!offlineModule]);

  const getActulalIndexes = async () => {
    if (
      offlineModule?.current_lesson &&
      offlineModule?.current_lesson !== offlineModule?.final_test
    ) {
      const less = offlineModule?.lessons?.find((lesson) =>
        lesson?.activities
          ?.map((el) => el.id)
          ?.includes(offlineModule?.current_lesson.current_activity_id)
      );
      const act = less?.activities.find(
        (el) => el.id === offlineModule?.current_lesson.current_activity_id
      );
      if (act) {
        setCurrectActivity(act);
      }
      const tempModule = await getByID(offlineModule.id);
      if (tempModule) {
        await updateModule({
          ...tempModule,
          current_lesson: {
            current_activity_id: act?.id,
            id: less?.id,
          },
        });
      }
    }
  };

  useEffect(() => {
    getActulalIndexes();
  }, [offlineModule?.current_lesson]);

  const refetchModuleLocal = async () => {
    await getActulalIndexes();
    if (moduleId) {
      const data = await getByID(parseInt(moduleId, 10));
      if (data) {
        const lessons = await getLessonsWithCompletedStatuses(data.lessons);
        setOfflineModule({ ...data, lessons });
      }
    }
  };

  const skipModuleFetch = !moduleId || !isOnline;
  const { module, refetch: refetchModule } = courseApi.useGetModuleByIdQuery(
    { id: moduleId },
    {
      refetchOnMountOrArgChange: !skipModuleFetch,
      selectFromResult: ({ data }) => ({
        module: data?.data,
      }),
      skip: skipModuleFetch,
    }
  );

  useEffect(() => {
    if (isOnline && moduleId) {
      refetchModule();
    } else {
      refetchModuleLocal();
    }
  }, [isOnline, moduleId]);

  const skipLessonActivityFetch = !currentActivity?.id || !isOnline;
  const { activity, refetch: refetchActivity } =
    courseApi.useGetLessonActivityByIdQuery(
      { id: currentActivity?.id },
      {
        refetchOnMountOrArgChange: !skipLessonActivityFetch,
        selectFromResult: ({ data }) => ({
          activity: data?.data,
        }),
        skip: skipLessonActivityFetch,
      }
    );

  const skipTestFetch = !module?.test_id || !isOnline;
  const { refetch: refetchTest, test } = testApi.useGetTestByIdQuery(
    { id: module?.test_id },
    {
      refetchOnMountOrArgChange: !skipTestFetch,
      selectFromResult: ({ data }) => ({
        test: data?.data,
      }),
      skip: skipTestFetch,
    }
  );

  const [updateProgress, { isLoading: isUpdateProgressMutationLoading }] =
    userApi.useUpdateUserProgressMutation();

  const [validateTest] = testApi.useValidateTestByIdMutation();
  const [updateTestProgress] = userApi.useUpdateOneTestProgressMutation();
  const [createTestProgress] = userApi.useUpdateTestProgressMutation();

  const { modules } = courseApi.useGetAllModulesQuery(undefined, {
    selectFromResult: ({ data }) => ({
      modules: data?.data?.modules,
    }),
    skip: !isOnline,
  });

  const getNextRoute = () => {
    if (modules && module) {
      const tempCourseModules = modules.filter(
        (m) => m.course_id === module.course_id
      );

      const tempCourseModulesIds = tempCourseModules.map((el) => el.id);

      const isLastInCourse = modules.every((item) => item.is_completed);

      if (isLastInCourse) {
        return routes.courses;
      }

      const nextModuleID = tempCourseModulesIds.indexOf(module.id) + 1;

      return tempCourseModules[nextModuleID]?.id
        ? `${routes.courses}/${module.course_id}/${tempCourseModules[nextModuleID]?.id}`
        : routes.courses;
    }
  };

  const { data: userData, refetch } = userApi.useGetUserQuery(undefined, {
    skip: !isOnline,
  });

  useEffect(() => {
    if (!isOnline) return;
    refetch();
  }, []);
  if (!isOnline) {
    return {
      activity: currectActivity,
      createTestProgress: createTestProgressLocal,
      getNextRoute: () => routes.offlineContent,
      isOffline: true,
      isUpdateProgressMutationLoading: false,
      module: offlineModule,
      refetchActivity: () => {},
      refetchModule: refetchModuleLocal,
      refetchTest: () => {},
      refetchUser: () => {},
      test: offlineModule?.final_test,
      updateProgress: updateProgressLocal,
      updateTestProgress: updateTestProgressLocal,
      userData: null,
      validateTest: validateTestLocal,
    };
  }

  return {
    activity,
    createTestProgress,
    getNextRoute,
    isOffline: false,
    isUpdateProgressMutationLoading,
    module,
    refetchActivity,
    refetchModule,
    refetchTest,
    refetchUser: refetch,
    test,
    updateProgress,
    updateTestProgress,
    userData: userData?.data,
    validateTest,
  };
};
